import {
	debounce,
	takeLatest,
	throttle,
	getTargetElement,
	hostMap,
	modifierTypes
} from './modifiers';
import runEffect from './runEffect';

export default function effectRunner(effect, ctx, ...args) {
	const {effect: effectFn, modifier = {}} = effect;
	const coeffects = args[args.length - 1];
	if (!coeffects) return runEffect(effectFn, args, ctx);

	const targetElement = getTargetElement(coeffects);
	switch (modifier.name) {
		case modifierTypes.DEBOUNCE:
			return debounce(
				targetElement,
				coeffects.action.type,
				effectFn,
				modifier,
				ctx,
				runEffect
			)(...args);
		case modifierTypes.TAKE_LATEST:
			return runEffect(takeLatest(targetElement, coeffects.action.type, effectFn), args, ctx).then(
				() => {
					delete hostMap.get(targetElement).get(effectFn)[coeffects.action.type];
				}
			);
		case modifierTypes.THROTTLE:
			return throttle(
				targetElement,
				coeffects.action.type,
				effectFn,
				modifier,
				ctx,
				runEffect
			)(...args);
		default:
			return runEffect(effectFn, args, ctx);
	}
}
